// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 169 ? "3fb82539" : chunkId) + "." + {"139":"e0b8da9815ba2cf2","145":"ac6cff3909d6aa48","169":"5cc66d7623c441cb","774":"9a417f988ce0fdcb"}[chunkId] + ".js";
};